import React from "react"
import { injectIntl } from "gatsby-plugin-intl"

const AboutResearch = ( { intl } ) => (
  <div className="block text research">
    <label className="label hidden">{ intl.formatMessage( { id: "about.research.label" } ) }</label>
    <div className="content">
      <h2 className="title hidden">{ intl.formatMessage( { id: "about.research.title" } ) }</h2>
      <p className="text hidden">{ intl.formatMessage( { id: "about.research.text" } ) }</p>
      <a className="button hidden" href="/research" target="_blank" rel="noopener noreferrer">{ intl.formatMessage( { id: "about.research.button" } ) }</a>
    </div>
  </div>
)

const inject = injectIntl( AboutResearch )
export { inject as AboutResearch }
